import { CURVA_FORMAT, CURVA_SCHEMA_VERSION, type CurvaDocumentJson } from "./curvaFile";

export function validateCurvaDocumentJson(value: unknown): CurvaDocumentJson {
  if (!isRecord(value)) {
    throw new Error("Curva package document.json must be an object.");
  }

  if (value.format !== CURVA_FORMAT) {
    throw new Error("Unsupported Curva package format.");
  }

  if (value.version !== CURVA_SCHEMA_VERSION) {
    throw new Error(`Unsupported Curva schema version: ${String(value.version)}.`);
  }

  if (!isRecord(value.document)) {
    throw new Error("Curva package document graph is missing.");
  }

  if (typeof value.document.id !== "string" || typeof value.document.name !== "string") {
    throw new Error("Curva document is missing required identity fields.");
  }

  if (!Array.isArray(value.document.pages)) {
    throw new Error("Curva document pages must be an array.");
  }

  if (value.document.styles !== undefined && typeof value.document.styles !== "object") {
    throw new Error("Curva document styles must be an object.");
  }

  if (
    value.document.styles &&
    typeof value.document.styles === "object" &&
  "items" in value.document.styles &&
    value.document.styles.items !== undefined &&
    !Array.isArray(value.document.styles.items)
  ) {
    throw new Error("Curva document styles.items must be an array.");
  }

  return value as unknown as CurvaDocumentJson;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
